import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Field } from 'redux-form'
import classnames from 'classnames'
import Svg from 'components/util/Svg'
import fieldProps from '../fieldProps'
import switchStyles from './_radioSwitch.css'
import buttonStyles from './_radioButton.css'
import FieldError from '../FieldError'

export class RadioField extends Component {

  static propTypes = fieldProps;

  state = {
    focus: false,
  }

  handleFocus = () => {
    this.setState({ focus: true })
    this.props.input.onFocus()
  }

  handleBlur = () => {
    this.setState({ focus: false })
    this.props.input.onBlur()
  }

  handleChange = () => {
    this.props.input.onChange(this.props.radioValue)
  }

  render () {
    const {
      slim,
      input,
      meta,
      labelComponent,
      errorComponent,
      required,
      disabled,
      radioValue,
      icon,
      button,
    } = this.props

    const selected = input.value === radioValue
    const styles = button ? buttonStyles : switchStyles

    return (
      <label
        htmlFor={name + radioValue}
        className={classnames(styles.container, this.props.className, {
          [styles.slim]: slim,
          [styles.disabled]: disabled,
          [styles.selected]: selected,
          [styles.focused]: this.state.focus,
          [styles.inputError]: meta.touched && meta.error,
        })}
      >

        {!button ?
          <div className={styles.iconContainer}>
            {icon
              ? <Svg name={icon} className={styles.icon} />
              : <span className={styles.iconDot} />
            }
          </div>
        : null}

        <input
          {...input}
          id={name + radioValue}
          type='radio'
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          onChange={this.handleChange}
          className={classnames(styles.input, {
            [styles.error]: meta.touched && meta.error,
          })}
        />

        {labelComponent ?
          <div className={styles.label}>
            {React.cloneElement(labelComponent, { selected: selected })}
            {required && <b className={styles.required}>{'*'}</b>}
          </div>
        : null}

        {button ?
          <div>
            {icon ?
              <Svg name={icon} className={classnames(styles.icon, {
                [styles.selected]: selected,
              })} />
            :
              <div className={styles.iconContainer}>
                <span className={styles.iconDot} />
              </div>
            }
          </div>
        : null}

        {(meta.touched && meta.error && errorComponent) ?
          <FieldError
            errorComponent={errorComponent}
            showError={!!(meta.touched && meta.error)}
            errorMessage={meta.error}
          />
        : null}

      </label>
    )
  }
}

RadioField.propTypes = fieldProps

export const renderField = (field) => (
  <RadioField {...field} />
)

export const FieldWrapper = ({ value, ...props }) => (
  <Field {...props} radioValue={value} component={renderField} />
)

FieldWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  error: PropTypes.node,
  label: PropTypes.node,
  disabled: PropTypes.bool,
}

export default FieldWrapper
